import HamburgerMenu from "@components/hamburgerMenu/";

const content = document.querySelector('[data-hamburger-menu-content]');
const toggleButton = document.querySelector('[data-hamburger-menu-toggle]');

const configuration = {
    toggleButton,
    content,
}

// eslint-disable-next-line no-new
new HamburgerMenu(configuration);

const findAHomeSubmenu = document.querySelector('[data-find-a-home]');
const resourcesSubmenu = document.querySelector('[data-resources]');

/**
 * accordionToggleHandle: Handles when some accordion menu opens or closes.
 * @param {Event} event Change event related to the opening or closing accordion menu.
 */
function accordionToggleHandle(event, container) {
  const accordionMenus = container.querySelectorAll('[data-menu-accordion-toggle]');
  accordionMenus.forEach(menu => {
    if (!event.target.isSameNode(menu)) {
      menu.checked = false;
    }
  });
}

findAHomeSubmenu.addEventListener('change', (event) => accordionToggleHandle(event, findAHomeSubmenu));
resourcesSubmenu.addEventListener('change', (event) => accordionToggleHandle(event, resourcesSubmenu));
